<template>
  <div class="ui-box-item">
    <titleComponents :show.sync="show" :name="titleName" :printShow="true" @onPrint="print"></titleComponents>
    <div class="itemInfo-detail" v-show="show">
      <div id="charts" class="charts">
        <canvas :id="type+'canvas'" width="1920" height="2714"></canvas>
      </div>
      <div class="ui-score">
        <el-row>
          <el-col :span="18">
            <div class="table">
              <table class="score-table">
                <tr>
                  <th>项目</th>
                  <th>0分</th>
                  <th>1分</th>
                  <th>2分</th>
                  <th>结果</th>
                  <th>评分</th>
                </tr>
                <tr>
                  <td>胎心基线(bmp)</td>
                  <td>&lt;110;&nbsp;&gt;160</td>
                  <td>110-119;&nbsp;151-160</td>
                  <td>120-150</td>
                  <td>{{score&&score.baseline}}</td>
                  <td>{{score&&score.fischer_score.baseline}}</td>
                </tr>
                <tr>
                  <td>振幅变异</td>
                  <td>&lt;2</td>
                  <td>2-5;&nbsp;&gt;25</td>
                  <td>6-25</td>
                  <td>{{score&&score.variability_cat}}</td>
                  <td>{{score&&score.fischer_score.variability_amp}}</td>
                </tr>
                <tr>
                  <td>变异频率</td>
                  <td>&lt;3</td>
                  <td>3-6</td>
                  <td>&gt;6</td>
                  <td>{{score&&score.ltv_frequency}}</td>
                  <td>{{score&&score.fischer_score.variability_freq}}</td>
                </tr>
                <tr>
                  <td>加速次数</td>
                  <td>0</td>
                  <td>1</td>
                  <td>&gt;=2</td>
                  <td>{{score&&score.acceleration_count}}</td>
                  <td>{{score&&score.fischer_score.accelerations}}</td>
                </tr>
                <tr>
                  <td>减速次数</td>
                  <td>VD,LD,PD</td>
                  <td>ED</td>
                  <td>0</td>
                  <td>{{score&&score.deceleration_type}}</td>
                  <td>{{score&&score.fischer_score.decelerations}}</td>
                </tr>
              </table>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="resultBox">
              <div class="resultTitle">评分结果</div>
              <div class="resultItem">评分时长：{{score&&score.duration}}</div>
              <div class="resultItem">评分标准：Fischer</div>
              <div class="resultItem">评分时间：{{score&&score.scoreTime.format('yyyy年MM月dd日 hh:mm:ss')}}</div>
              <div class="resultItem">总分：FHR={{score&&score.fischer_score.total}}</div>
              <div class="resultTitle marginTop20">心律检测</div>
              <div class="resultItem">心律失常：{{score&&arrhythmia_type_str[score.arrhythmia_type]}}</div>
              <div class="resultItem">详情：{{score&&score.arrhythmia_details}}</div>
            </div>
          </el-col>
        </el-row>
      </div>
      <chartComponents :canvasId="type+'heartChart1'" :ref="type+'chart1'" :list="valueList" :viewportStart="0" :currentTime="600"></chartComponents>
      <chartComponents :canvasId="type+'heartChart2'" :ref="type+'chart2'" :list="valueList" :viewportStart="600" :currentTime="1200"></chartComponents>
      <div class="remark">说明：此报告仅供临床参考，不做诊断证明之用</div>
    </div>
  </div>
</template>

<script>
import printJS from 'print-js'
import fetalScore from '@/utils/fetalScore.js'
import titleComponents from '@/components/mother/title'
import chartComponents from '@/components/heartDetail/chart'
import heartData from '@/utils/heartData.js'
export default {
  name: 'heartInfo',
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    type: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      heartClass: null,
      valueList: [],
      dataList: {
        fhrList: [],
        tocoList: [],
        tocoResetList: [],
        autoMove: [],
        manualMove: [],
      },
      score: null,
      show: true,
      scoreList: [
        ['项目', '0分', '1分', '2分', '结果', '评分'],
        ['胎心基线(bmp)', '<110; >160', '110-119; 151-160', '120-150', '', ''],
        ['振幅变异', '<2', '2-5; >25', '6-25', '', ''],
        ['变异频率', '<3', '3-6', '>6', '', ''],
        ['加速次数', '0', '1', '>=2', '', ''],
        ['减速次数', 'VD,LD,PD', 'ED', '0', '', '']
      ],
      arrhythmia_type_str: {
        0: "无",
        1: "心动过缓",
        2: "心动过速",
        3: "低变异性",
        4: "异常加速",
        5: "异常减速",
        6: "房室传导阻滞",
      },
    }
  },
  created () {
    this.heartClass = new heartData()
  },
  mounted () {
    this.getScore()
  },
  computed: {
    titleName () {
      return this.type == 1 ? '胎心一' : '胎心二'
    }
  },
  methods: {
    canvasInit () {
      const canvas = document.getElementById(this.type + 'canvas');
      const ctx = canvas.getContext('2d');

      // 绘制背景
      ctx.textBaseline = "middle"
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // 绘制标题
      let lineHeight = 72
      let fontSize = 51;
      let marginTop = 66;
      let y = marginTop + lineHeight / 2
      ctx.font = `${fontSize}px PingFang SC`;
      ctx.fillStyle = "black";
      ctx.textAlign = "center";
      ctx.fillText(this.data.tbUserHospitalName + '远程胎心监护图一', canvas.width / 2, y);

      // 绘制患者信息
      lineHeight = 37
      fontSize = 20;
      marginTop = 172;
      y = marginTop + lineHeight / 2
      let startX = 48
      let horizontalWidth = (canvas.width - startX * 2) / 4
      ctx.font = `${fontSize}px PingFang SC`;
      ctx.textAlign = "left";
      ctx.fillText("姓名：" + this.data.username, startX + horizontalWidth * 0, y);
      ctx.fillText("年龄：" + (this.data.age ? this.data.age + '岁' : ''), startX + horizontalWidth * 1, y);
      ctx.fillText("孕周：" + this.data.week, startX + horizontalWidth * 2, y);
      ctx.fillText("手机号：" + this.data.phone, startX + horizontalWidth * 3, y);

      // 绘制监护时间信息
      marginTop = 235;
      y = marginTop + lineHeight / 2
      ctx.fillText("监护开始时间：" + this.data.tbStartTime, startX + horizontalWidth * 0, y);
      ctx.fillText("监护结束时间：" + this.data.tbEndTime, startX + horizontalWidth * 1, y);
      ctx.fillText("监护时长：" + this.calculateTimeDifference(this.data.tbStartTime, this.data.tbEndTime), startX + horizontalWidth * 2, y);

      // 绘制说明
      marginTop = 1257;
      y = marginTop + lineHeight / 2
      ctx.fillText("说明：此报告仅供临床参考，不做诊断证明之用", startX + horizontalWidth * 0, y);

      // 绘制说明
      marginTop = 900 + 1600;
      y = marginTop + lineHeight / 2
      ctx.fillText("说明：此报告仅供临床参考，不做诊断证明之用", startX + horizontalWidth * 0, y);


      //绘制评分表格 - 绘制水平网格
      lineHeight = 55
      let lineNum = 7
      let width = 1358;
      let height = lineHeight * (lineNum - 1);
      startX = 48
      marginTop = 307
      ctx.strokeStyle = '#575757';
      ctx.lineWidth = 2;
      for (let i = 0; i < lineNum; i++) {
        ctx.moveTo(startX, marginTop + lineHeight * i);
        ctx.lineTo(startX + width, marginTop + lineHeight * i);
        ctx.stroke();
      }
      //绘制评分表格 - 绘制垂直网格
      let lineWidth = width / (lineNum - 1);
      for (let i = 0; i < lineNum; i++) {
        ctx.moveTo(startX + lineWidth * i, marginTop);
        ctx.lineTo(startX + lineWidth * i, marginTop + height);
        ctx.stroke();
      }
      //绘制评分表格 - 录入表格数据
      ctx.textAlign = "center";
      for (let j = 0; j < this.scoreList.length; j++) {
        for (let i = 0; i < this.scoreList[j].length; i++) {
          ctx.fillText(this.scoreList[j][i], startX + lineWidth * i + lineWidth / 2, marginTop + lineHeight * j + lineHeight / 2);
        }
      }
      //绘制评分结果 - 绘制边框
      startX = 1423
      width = 451
      ctx.moveTo(startX, marginTop);
      ctx.lineTo(startX + width, marginTop);
      ctx.moveTo(startX, marginTop);
      ctx.lineTo(startX, marginTop + height);
      ctx.moveTo(startX, marginTop + height);
      ctx.lineTo(startX + width, marginTop + height);
      ctx.moveTo(startX + width, marginTop);
      ctx.lineTo(startX + width, marginTop + height);
      ctx.stroke();
      //绘制评分结果 - 绘制评分信息
      fontSize = 18
      ctx.textAlign = "left";
      ctx.font = `600 ${fontSize}px PingFang SC`;
      startX = 1440
      lineHeight = 37
      marginTop = 315
      ctx.fillText(`评分结果`, startX, marginTop + lineHeight * 0 + lineHeight / 2);
      ctx.font = `${fontSize}px PingFang SC`;
      ctx.fillText(`评分时长：${this.score.duration}`, startX, marginTop + lineHeight * 1 + lineHeight / 2);
      ctx.fillText(`评分标准：Fischer`, startX, marginTop + lineHeight * 2 + lineHeight / 2);
      ctx.fillText(`评分时间：${this.score.scoreTime.format('yyyy年MM月dd日 hh:mm:ss')}`, startX, marginTop + lineHeight * 3 + lineHeight / 2);
      ctx.fillText(`总分：FHR=${this.score.fischer_score.total}`, startX, marginTop + lineHeight * 4 + lineHeight / 2);
      ctx.font = `600 ${fontSize}px PingFang SC`;
      marginTop = 516
      ctx.fillText(`心律检测`, startX, marginTop + lineHeight * 0 + lineHeight / 2);
      ctx.font = `${fontSize}px PingFang SC`;
      ctx.fillText(`心律失常：${this.arrhythmia_type_str[this.score.arrhythmia_type]}`, startX, marginTop + lineHeight * 1 + lineHeight / 2);
      ctx.fillText(`详情：${this.score.arrhythmia_details}`, startX, marginTop + lineHeight * 2 + lineHeight / 2);

      //绘制曲线1
      const yData = [50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220]
      lineNum = (220 - 50) / 10 + 1
      startX = 48
      width = canvas.width - startX - 46;
      height = 345;
      lineHeight = height / (lineNum - 1);
      marginTop = 666
      // 绘制水平网格
      const minY = 0;
      let maxY = height;
      ctx.strokeStyle = '#000000';
      ctx.lineWidth = 1;
      for (let i = 0; i < lineNum; i++) {
        if (i % 3 == 1 || i == 0) {
          ctx.strokeStyle = '#575757';
        } else {
          ctx.strokeStyle = '#B0B0B0';
        }
        const value = minY + i * lineHeight;
        const y = height - ((value - minY) / (maxY - minY)) * height;
        ctx.beginPath();
        ctx.moveTo(startX, y + marginTop);
        ctx.lineTo(width + startX, y + marginTop);
        ctx.stroke();
      }
      // 添加Y轴刻度标签
      ctx.font = "14px PingFang SC";
      ctx.fillStyle = "black";
      ctx.textAlign = "center";
      for (let i = 0; i < lineNum; i++) {
        if (i % 3 == 1) {
          ctx.fillText(yData[yData.length - i - 1], startX - 15, lineHeight * i + marginTop);
        }
      }
      // 绘制垂直网格（21条，每20秒一个刻度）
      const totalMinutes = 10; // 20分钟
      const verticalGrids = Math.round(totalMinutes * 3) + 1; // 20条垂直线
      const verticalSpacing = width / (verticalGrids - 1);
      ctx.lineWidth = 1;
      for (let i = 0; i < verticalGrids; i++) {
        const x = i * verticalSpacing;
        ctx.beginPath();
        if (i % 3 == 0) {
          ctx.setLineDash([]);
        } else {
          ctx.setLineDash([5, 10]);
        }
        ctx.moveTo(x + startX, marginTop);
        ctx.lineTo(x + startX, height + marginTop);
        ctx.stroke();
      }
      // 添加X轴刻度标签
      for (let i = 0; i < verticalGrids; i++) {
        const x = i * verticalSpacing;
        if (i % 3 == 0 && i != 0) {
          ctx.fillText(`${i / 3}’`, x + startX, height + marginTop + 15);
        }
      }
      //  绘制绿色参考区域（110-160单位）
      let greenTop = height - ((minY + (110 - yData[0]) / 10 * lineHeight - minY) / (maxY - minY)) * height;
      let greenBottom = height - ((minY + (160 - yData[0]) / 10 * lineHeight - minY) / (maxY - minY)) * height;
      ctx.fillStyle = 'rgba(152,218,156,0.5)';
      ctx.fillRect(startX, greenTop + marginTop, width, greenBottom - greenTop);
      //  绘制数据线
      ctx.strokeStyle = '#575757';
      ctx.setLineDash([]);
      ctx.lineWidth = 2;
      const dataGrids = 10 * 60 * 4; // 20分钟 每秒4个点
      const dataSpacing = width / (10 * 60 * 4);
      let seriesData = [...this.dataList.fhrList]
      let totalDataLength = seriesData.length > dataGrids ? dataGrids : seriesData.length;
      for (let i = 0; i < totalDataLength; i++) {
        if (seriesData[i].draw) {
          const x = i * dataSpacing;
          const y = height - ((minY + (seriesData[i].value - yData[0]) / 10 * lineHeight - minY) / (maxY - minY)) * height;
          let nextY = y
          if (i + 1 < totalDataLength && seriesData[i + 1].draw) {
            nextY = height - ((minY + (seriesData[i + 1].value - yData[0]) / 10 * lineHeight - minY) / (maxY - minY)) * height;
          }
          ctx.beginPath();
          ctx.moveTo(x + startX, marginTop + y);
          ctx.lineTo(x + startX + dataSpacing, marginTop + nextY);
          ctx.stroke();
        }
      }
      // 绘制自动胎动
      ctx.beginPath();
      ctx.fillStyle = '#28CEBC';
      ctx.strokeStyle = "#28CEBC";
      let autoMove = []
      autoMove = this.dataList.autoMove.filter(i => i <= 600)
      for (let i = 0; i < autoMove.length; i++) {
        ctx.arc(autoMove[i] * dataSpacing * 4 + startX, lineHeight * 2 + marginTop, 4, 0, 2 * Math.PI);
        ctx.fill();
      }

      // 绘制手动胎动
      ctx.beginPath();
      ctx.fillStyle = '#AEB9FE';
      ctx.strokeStyle = "#AEB9FE";
      let manualMove = []
      manualMove = this.dataList.manualMove.filter(i => i <= 600)
      for (let i = 0; i < manualMove.length; i++) {
        ctx.arc(manualMove[i] * dataSpacing * 4 + startX, lineHeight * 2 + marginTop, 4, 0, 2 * Math.PI);
        ctx.fill();
      }

      // 绘制宫缩复位标记
      ctx.beginPath();
      ctx.fillStyle = '#3F9EFF';
      ctx.strokeStyle = "#3F9EFF";
      ctx.lineWidth = 2;
      let tocoReset = []
      tocoReset = this.dataList.tocoResetList.filter(i => i <= 600)
      for (let i = 0; i < tocoReset.length; i++) {
        const x = tocoReset[i] * dataSpacing * 4 + startX
        const y = lineHeight * 2 + marginTop
        ctx.moveTo(x - 8 / 2, y);
        ctx.lineTo(x + 8 / 2, y);
        ctx.moveTo(x, y - 8 / 2);
        ctx.lineTo(x, y + 8 / 2);
      }
      ctx.stroke();

      // 绘制宫缩曲线
      marginTop = 1040
      // 绘制水平网格
      ctx.strokeStyle = '#B0B0B0';
      ctx.lineWidth = 1;
      lineNum = 11
      height = lineHeight * (lineNum - 1);
      maxY = height
      for (let i = 0; i < lineNum; i++) {
        const y = lineHeight * i
        ctx.beginPath();
        ctx.moveTo(startX, y + marginTop);
        ctx.lineTo(width + startX, y + marginTop);
        ctx.stroke();
      }
      const yData2 = [0, 20, 40, 60, 80, 100]
      // 添加Y轴刻度标签
      ctx.font = "14px PingFang SC";
      ctx.fillStyle = "black";
      ctx.textAlign = "center";
      for (let i = 0; i < lineNum; i++) {
        if (i % 2 == 0) {
          ctx.fillText(yData2[yData2.length - (i / 2) - 1], startX - 15, lineHeight * i + marginTop);
        }
      }
      // 绘制垂直网格（21条，每20秒一个刻度）
      ctx.lineWidth = 1;
      for (let i = 0; i < verticalGrids; i++) {
        const x = i * verticalSpacing;
        ctx.beginPath();
        if (i % 3 == 0) {
          ctx.setLineDash([]);
        } else {
          ctx.setLineDash([5, 10]);
        }
        ctx.moveTo(x + startX, marginTop);
        ctx.lineTo(x + startX, height + marginTop);
        ctx.stroke();
      }
      //  绘制数据线
      ctx.strokeStyle = '#575757';
      ctx.setLineDash([]);
      ctx.lineWidth = 2;
      seriesData = [...this.dataList.tocoList]
      totalDataLength = seriesData.length > dataGrids ? dataGrids : seriesData.length;
      for (let i = 0; i < totalDataLength; i++) {
        const x = i * dataSpacing;
        const y = height - ((minY + (seriesData[i] - yData2[0]) / 10 * lineHeight - minY) / (maxY - minY)) * height;
        let nextY = y
        if (i + 1 < totalDataLength && seriesData[i + 1]) {
          nextY = height - ((minY + (seriesData[i + 1] - yData2[0]) / 10 * lineHeight - minY) / (maxY - minY)) * height;
        }
        ctx.beginPath();
        ctx.moveTo(x + startX, marginTop + y);
        ctx.lineTo(x + startX + dataSpacing, marginTop + nextY);
        ctx.stroke();
      }


      // 绘制标题
      lineHeight = 72
      fontSize = 51;
      marginTop = 66 + 1600;
      y = marginTop + lineHeight / 2
      ctx.font = `${fontSize}px PingFang SC`;
      ctx.fillStyle = "black";
      ctx.textAlign = "center";
      ctx.fillText(this.data.tbUserHospitalName + '远程胎心监护图二', canvas.width / 2, y);

      // 绘制患者信息
      lineHeight = 37
      fontSize = 20;
      marginTop = 172 + 1600;
      y = marginTop + lineHeight / 2
      startX = 48
      horizontalWidth = (canvas.width - startX * 2) / 4
      ctx.font = `${fontSize}px PingFang SC`;
      ctx.textAlign = "left";
      ctx.fillText("姓名：" + this.data.username, startX + horizontalWidth * 0, y);
      ctx.fillText("年龄：" + (this.data.age ? this.data.age + '岁' : ''), startX + horizontalWidth * 1, y);
      ctx.fillText("孕周：" + this.data.week, startX + horizontalWidth * 2, y);
      ctx.fillText("手机号：" + this.data.phone, startX + horizontalWidth * 3, y);

      // 绘制监护时间信息
      marginTop = 235 + 1600;
      y = marginTop + lineHeight / 2
      ctx.fillText("监护开始时间：" + this.data.tbStartTime, startX + horizontalWidth * 0, y);
      ctx.fillText("监护结束时间：" + this.data.tbEndTime, startX + horizontalWidth * 1, y);
      ctx.fillText("监护时长：" + this.calculateTimeDifference(this.data.tbStartTime, this.data.tbEndTime), startX + horizontalWidth * 2, y);


      //绘制曲线2
      lineNum = (220 - 50) / 10 + 1
      startX = 48
      width = canvas.width - startX - 46;
      height = 345;
      lineHeight = height / (lineNum - 1);
      marginTop = 307 + 1600;
      // 绘制水平网格
      maxY = height;
      ctx.strokeStyle = '#000000';
      ctx.lineWidth = 1;
      for (let i = 0; i < lineNum; i++) {
        if (i % 3 == 1 || i == 0) {
          ctx.strokeStyle = '#575757';
        } else {
          ctx.strokeStyle = '#B0B0B0';
        }
        const value = minY + i * lineHeight;
        const y = height - ((value - minY) / (maxY - minY)) * height;
        ctx.beginPath();
        ctx.moveTo(startX, y + marginTop);
        ctx.lineTo(width + startX, y + marginTop);
        ctx.stroke();
      }
      // 添加Y轴刻度标签
      ctx.font = "14px PingFang SC";
      ctx.fillStyle = "black";
      ctx.textAlign = "center";
      for (let i = 0; i < lineNum; i++) {
        if (i % 3 == 1) {
          ctx.fillText(yData[yData.length - i - 1], startX - 15, lineHeight * i + marginTop);
        }
      }
      // 绘制垂直网格（21条，每20秒一个刻度）
      ctx.lineWidth = 1;
      for (let i = 0; i < verticalGrids; i++) {
        const x = i * verticalSpacing;
        ctx.beginPath();
        if (i % 3 == 0) {
          ctx.setLineDash([]);
        } else {
          ctx.setLineDash([5, 10]);
        }
        ctx.moveTo(x + startX, marginTop);
        ctx.lineTo(x + startX, height + marginTop);
        ctx.stroke();
      }
      // 添加X轴刻度标签
      for (let i = 0; i < verticalGrids; i++) {
        const x = i * verticalSpacing;
        if (i % 3 == 0 && i != 0) {
          ctx.fillText(`${i / 3}’`, x + startX, height + marginTop + 15);
        }
      }
      //  绘制绿色参考区域（110-160单位）
      greenTop = height - ((minY + (110 - yData[0]) / 10 * lineHeight - minY) / (maxY - minY)) * height;
      greenBottom = height - ((minY + (160 - yData[0]) / 10 * lineHeight - minY) / (maxY - minY)) * height;
      ctx.fillStyle = 'rgba(152,218,156,0.5)';
      ctx.fillRect(startX, greenTop + marginTop, width, greenBottom - greenTop);
      //  绘制数据线
      ctx.strokeStyle = '#575757';
      ctx.setLineDash([]);
      ctx.lineWidth = 2;
      seriesData = [...this.dataList.fhrList]
      if (seriesData.length > dataGrids) {
        seriesData.splice(0, dataGrids)
      } else {
        seriesData = []
      }
      totalDataLength = seriesData.length > dataGrids ? dataGrids : seriesData.length;
      for (let i = 0; i < totalDataLength; i++) {
        if (seriesData[i].draw) {
          const x = i * dataSpacing;
          const y = height - ((minY + (seriesData[i].value - yData[0]) / 10 * lineHeight - minY) / (maxY - minY)) * height;
          let nextY = y
          if (i + 1 < totalDataLength && seriesData[i + 1].draw) {
            nextY = height - ((minY + (seriesData[i + 1].value - yData[0]) / 10 * lineHeight - minY) / (maxY - minY)) * height;
          }
          ctx.beginPath();
          ctx.moveTo(x + startX, marginTop + y);
          ctx.lineTo(x + startX + dataSpacing, marginTop + nextY);
          ctx.stroke();
        }
      }
      // 绘制自动胎动
      ctx.beginPath();
      ctx.fillStyle = '#28CEBC';
      ctx.strokeStyle = "#28CEBC";
      autoMove = this.dataList.autoMove.filter(i => {
        return i > 600 && i <= 1200
      })
      for (let i = 0; i < autoMove.length; i++) {
        ctx.arc((autoMove[i] - 600) * dataSpacing * 4 + startX, lineHeight * 2 + marginTop, 4, 0, 2 * Math.PI);
        ctx.fill();
      }

      // 绘制手动胎动
      ctx.beginPath();
      ctx.fillStyle = '#AEB9FE';
      ctx.strokeStyle = "#AEB9FE";
      manualMove = this.dataList.manualMove.filter(i => i > 600 && i <= 1200)
      for (let i = 0; i < manualMove.length; i++) {
        ctx.arc((manualMove[i] - 600) * dataSpacing * 4 + startX, lineHeight * 2 + marginTop, 4, 0, 2 * Math.PI);
        ctx.fill();
      }

      // 绘制宫缩复位标记
      ctx.beginPath();
      ctx.fillStyle = '#3F9EFF';
      ctx.strokeStyle = "#3F9EFF";
      ctx.lineWidth = 2;
      tocoReset = this.dataList.tocoResetList.filter(i => i > 600 && i <= 1200)
      for (let i = 0; i < tocoReset.length; i++) {
        const x = (tocoReset[i] - 600) * dataSpacing * 4 + startX
        const y = lineHeight * 2 + marginTop
        ctx.moveTo(x - 8 / 2, y);
        ctx.lineTo(x + 8 / 2, y);
        ctx.moveTo(x, y - 8 / 2);
        ctx.lineTo(x, y + 8 / 2);
      }
      ctx.stroke();

      // 绘制宫缩曲线2
      marginTop = 681 + 1600
      // 绘制水平网格
      ctx.strokeStyle = '#B0B0B0';
      ctx.lineWidth = 1;
      lineNum = 11
      height = lineHeight * (lineNum - 1);
      maxY = height
      for (let i = 0; i < lineNum; i++) {
        const y = lineHeight * i
        ctx.beginPath();
        ctx.moveTo(startX, y + marginTop);
        ctx.lineTo(width + startX, y + marginTop);
        ctx.stroke();
      }
      // 添加Y轴刻度标签
      ctx.font = "14px PingFang SC";
      ctx.fillStyle = "black";
      ctx.textAlign = "center";
      for (let i = 0; i < lineNum; i++) {
        if (i % 2 == 0) {
          ctx.fillText(yData2[yData2.length - (i / 2) - 1], startX - 15, lineHeight * i + marginTop);
        }
      }
      // 绘制垂直网格（21条，每20秒一个刻度）
      ctx.lineWidth = 1;
      for (let i = 0; i < verticalGrids; i++) {
        const x = i * verticalSpacing;
        ctx.beginPath();
        if (i % 3 == 0) {
          ctx.setLineDash([]);
        } else {
          ctx.setLineDash([5, 10]);
        }
        ctx.moveTo(x + startX, marginTop);
        ctx.lineTo(x + startX, height + marginTop);
        ctx.stroke();
      }
      //  绘制数据线
      ctx.strokeStyle = '#575757';
      ctx.setLineDash([]);
      ctx.lineWidth = 2;
      seriesData = [...this.dataList.tocoList]
      if (seriesData.length > dataGrids) {
        seriesData.splice(0, dataGrids)
      } else {
        seriesData = []
      }
      totalDataLength = seriesData.length > dataGrids ? dataGrids : seriesData.length;
      for (let i = 0; i < totalDataLength; i++) {
        const x = i * dataSpacing;
        const y = height - ((minY + (seriesData[i] - yData2[0]) / 10 * lineHeight - minY) / (maxY - minY)) * height;
        let nextY = y
        if (i + 1 < totalDataLength && seriesData[i + 1]) {
          nextY = height - ((minY + (seriesData[i + 1] - yData2[0]) / 10 * lineHeight - minY) / (maxY - minY)) * height;
        }
        ctx.beginPath();
        ctx.moveTo(x + startX, marginTop + y);
        ctx.lineTo(x + startX + dataSpacing, marginTop + nextY);
        ctx.stroke();
      }


    },
    calculateTimeDifference (startTime, endTime) {
      // 确保输入是Date对象
      const start = new Date(startTime);
      const end = new Date(endTime);

      // 计算时间差（毫秒）
      let difference = end - start;

      // 处理结束时间早于开始时间的情况
      if (difference < 0) {
        difference = -difference;
      }

      // 计算小时、分钟和秒
      const hours = Math.floor(difference / (1000 * 60 * 60));
      difference -= hours * (1000 * 60 * 60);
      const minutes = Math.floor(difference / (1000 * 60));
      difference -= minutes * (1000 * 60);
      const seconds = Math.floor(difference / 1000);
      return `${hours}小时${minutes}分钟${seconds}秒`;
    },
    getScore () {
      if (this.data?.tbId) {
        const data = this.type === 1 ? this.data.tbData : this.data.tbData2
        const tbScoreData = this.type === 1 ? this.data.tbScoreData : this.data.tbScoreData2
        this.score = fetalScore.score2(data, tbScoreData, this.data.tbStartTime, this.data.tbEndTime, this.data.tbEndTime, this.data.tbWeek)
        this.scoreList[1][4] = this.score.baseline
        this.scoreList[1][5] = this.score.fischer_score.baseline
        this.scoreList[2][4] = this.score.variability_cat
        this.scoreList[2][5] = this.score.fischer_score.variability_amp
        this.scoreList[3][4] = this.score.ltv_frequency
        this.scoreList[3][5] = this.score.fischer_score.variability_freq
        this.scoreList[4][4] = this.score.acceleration_count
        this.scoreList[4][5] = this.score.fischer_score.accelerations
        this.scoreList[5][4] = this.score.deceleration_type
        this.scoreList[5][5] = this.score.fischer_score.decelerations
        this.valueList = []
        if (this.type === 1 && this.data.tbData) {
          this.dataList.fhrList = this.data.tbData.split(',').map(i => this.heartClass.heartChange(Number(i)))
        } else if (this.type === 2 && this.data.tbData2) {
          this.dataList.fhrList = this.data.tbData2.split(',').map(i => this.heartClass.heartChange(Number(i)))
        }
        if (this.data.tbToco) {
          this.dataList.tocoList = this.data.tbToco.split(',').map(i => Number(i))
        }
        if (this.data.tbTocoReset) {
          this.dataList.tocoResetList = this.data.tbTocoReset.split(',').map(i => Number(i))
        }
        if (this.data.tbAutoMove) {
          this.dataList.autoMove = this.data.tbAutoMove.split(',').map(i => Number(i))
        }
        if (this.data.tbManualMove) {
          this.dataList.manualMove = this.data.tbManualMove.split(',').map(i => Number(i))
        }
        this.dataList.fhrList.forEach((i, index) => {
          const timerPoint = index / 4
          const form = {
            fhr: i,
            toco: 0,
            afmFlag: 0,
            manualMoveFlag: 0,
            tocoResetFlag: 0,
            timerPoint: timerPoint
          }
          if (this.data.tbIsHasToco) {
            form.toco = this.dataList.tocoList[index]
          }
          if (this.dataList.tocoResetList.some(i => i === timerPoint)) {
            form.tocoResetFlag = 1
          }
          if (this.dataList.manualMove.some(i => i === timerPoint)) {
            form.manualMoveFlag = 1
          }
          if (this.dataList.autoMove.some(i => i === timerPoint)) {
            form.afmFlag = 1
          }
          this.valueList.push(form)
        })
        this.$nextTick(() => {
          this.$refs[this.type + 'chart1'].drawChart()
          this.$refs[this.type + 'chart2'].drawChart()
          this.canvasInit()
        })
      }
    },
    print () {
      const canvas = document.getElementById(this.type + 'canvas');
      const imageDataUrl = canvas.toDataURL('image/png');
      printJS({
        printable: imageDataUrl,
        type: 'image',
        documentTitle: '',
        header: null,
        base64: true,
        style: `@media print { @page {size: auto; margin: 0; } body{margin:0; padding: 0;}}`,
        imageStyle: 'width: 100%; height: 1357px; margin:0; padding: 0;'
      });
    },
  },
  components: {
    titleComponents,
    chartComponents
  },
  watch: {
    'data.tbId': function (newVal, old) {
      if (newVal && newVal != old) {
        this.getScore()
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.ui-box-item {
  position: relative;
  margin: 20px 24px 0;
  background: rgba(0, 0, 0, 0.02);
  box-sizing: border-box;
  width: calc(100% - 48px);
  .charts {
    position: absolute;
    top: -6000px;
    width: 1920px;
    height: 2714px;
    background: #ffffff;
  }
  .itemInfo-detail {
    border-top: 1px solid #e5e5e5;
    width: 100%;
    padding: 20px 0;
    box-sizing: border-box;
    .ui-score {
      padding: 0 20px;
      width: 100%;
      box-sizing: border-box;
      .table {
        width: 100%;
        height: 331px;
        padding-right: 20px;
        box-sizing: border-box;
        .score-table {
          table-layout: fixed;
          text-align: center;
          width: 100%;
          border: 1px solid #575757;
          border-collapse: collapse;
          tr {
            border: 1px solid #575757;
            height: 54px;
            line-height: 54px;
            th {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 500;
              color: #000000;
              text-align: center;
              border: 1px solid #575757;
            }
            td {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #000000;
              border: 1px solid #575757;
              .ui-orderExpress {
                height: 30px;
                line-height: 30px;
              }
            }
          }
        }
      }

      .resultBox {
        width: 100%;
        height: 331px;
        border: 1px solid #575757;
        padding: 11px 21px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        .resultTitle {
          width: 100%;
          height: 29px;
          font-weight: 600;
          font-size: 19px;
          color: #000000;
          line-height: 29px;
          text-align: left;
          &.marginTop20 {
            margin-top: 20px;
          }
        }
        .resultItem {
          margin-top: 7px;
          width: 100%;
          height: 29px;
          font-weight: 400;
          font-size: 19px;
          color: #000000;
          line-height: 29px;
          text-align: left;
        }
      }
    }
    .remark {
      margin-top: 20px;
      margin-left: 20px;
    }
  }
}
</style>
     